// @flow
import $ from 'jquery';
import JQueryView, { on, removeInvalidFeedback } from '../../common/JQueryView';
import {
  addCommas,
  trimCommas,
  removeNonNumeric,
} from '../../../utils/commonUtils';

export default class FormView extends JQueryView {
  constructor() {
    super('.simple_form');

    $('.form-group-float').each((index, element) => {
      const control = $(element).find('.form-control');
      if (control.val().length !== 0) {
        control.addClass('form-control-active');
      } else {
        control.removeClass('form-control-active');
      }
    });

    this.formatValue($('#company_capital_event_round_stock_price'));
  }

  formatValue = ($target: any) => {
    $target.val(addCommas(removeNonNumeric($target.val())));
  };

  unformatValue = ($target: any) => {
    $target.val(trimCommas($target.val()));
  };

  onSubmit() {
    this.unformatValue($('#company_capital_event_round_stock_price'));
    return true;
  }

  @on({ event: 'click', selector: '#submit' })
  onClickSubmit() {
    this.onSubmit();
  }

  @on({ event: 'change', selector: '#company_capital_event_round_stock_price' })
  onChangeStockPrice(event: any) {
    const target = $(event.target);
    this.formatValue(target);
  }

  @on({ event: 'change', selector: '.form-control' })
  onChangeFormControl(event: any) {
    const target = $(event.target);
    if (target.val().length !== 0) {
      target.find('.form-control').addClass('form-control-active');
      target.removeClass('is-invalid');
      removeInvalidFeedback(target);
      target.removeClass('focus');
    }
  }

  @on({ event: 'blur input', selector: '.form-group-float, .form-control' })
  onBlurFormControl(event: any) {
    const target = $(event.target);
    if (target.val().length === 0) {
      target.removeClass('form-control-active');
    } else {
      target.addClass('form-control-active');
      target.removeClass('is-invalid');
      removeInvalidFeedback(target);
    }
  }
}
